<template>
	<main>
		<b-modal
			id="acceptrejectmodal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			v-model="showAcceptReject"
			@hidden="$emit('close-modal')"
		>
			<main>
				<header class="modal-top p-3">
					<div class="d-flex justify-content-between align-items-start">
						<div class="gap-3 width-97 mob-main">
							<img
								v-if="!type"
								src="@/assets/img/viewinterview/reject-icon.svg"
								alt
							/>
							<img
								v-else
								src="@/assets/img/viewinterview/accept-icon.svg"
								alt
							/>
							<div class="mob-text-center">
								<h2 class="candash-modal-head">
									{{ modalHeading }}
									{{ reschedule ? " Reschedule" : "Interview"
									}}{{ !cancel ? " Request" : "" }}
								</h2>
								<h3
									class="candash-desc mt-2 text-344054"
									style="line-height: 18px"
								>
									Are you sure you want to {{ modalHeading.toLowerCase() }} this
									interview
									{{ reschedule ? "reschedule request" : "for candidate" }}
									<strong>“{{ interview.name }}”</strong>
									on
									<strong>
										{{
											reschedule
												? getFormattedTime(interview.slot)
												: interview.slot
										}} </strong
									>?
									{{
										!type || cancel || reschedule
											? "This action cannot be undone."
											: ""
									}}
								</h3>
							</div>
						</div>
						<div class="pointer" id="hideinmobile">
							<img
								@click="$emit('close-modal')"
								class="rotate-on-hover"
								src="@/assets/newdesign/dashboard/blueCross.svg"
								alt
							/>
						</div>
					</div>
				</header>
				<div v-if="cancel" class="candash-modal-footer">
					<div class="teams-label-font d-flex w-16">
						Reason
						<span class="asterik">&nbsp;*</span>
					</div>
					<Textarea
						:v-model="$v.reason.$model"
						:showError="$v.reason.$error"
						:limit="256"
						@select-value="$v.reason.$model = $event"
						:noLabel="true"
						type="text"
						:mandatory="true"
						placeholder="Enter"
					/>
					<div
						class="newInt-required-validation-font mt-1"
						v-if="$v.reason.$error"
					>
						{{
							$v.reason.$dirty && !$v.reason.required
								? "Required"
								: "Exceeded the max char length of 256"
						}}
					</div>
				</div>
				<footer
					class="candash-modal-footer d-flex align-items-center justify-content-between mt-3 mob-jc-center"
				>
					<div v-if="cancel">
						<span
						    :class="!showReschedule() && 'opac-5'"
							class="reschedule-link fs-14 fw-500 pointer d-flex align-items-center"
							@click="showReschedule() ? $emit('reschedule-interview', interview) : ''"
							v-b-tooltip.hover.top="showReschedule() == null ? 'Cannot reschedule as the interview starts in less than 15 minutes' : !showReschedule() ? 'Already rescheduled' : ''"
						>
							<img
								src="@/assets/paneldashboard/reschedule.svg"
								alt="Reschedule"
								class="mr-1"
								width="18"
								height="18"
							/>
							<span class="fc-20639b">Reschedule Interview</span>
						</span>
					</div>

					<div class="d-flex align-items-center ml-auto">
						<b-button
							class="candash-cancelBtn pointer mr-3"
							@click="$emit('close-modal')"
						>
							Cancel
						</b-button>

						<div class="position-relative">
							<b-button
								class="candash-addBtn"
								:class="!LoaderStatus ? 'pointer' : 'opac-5'"
								@click="!LoaderStatus ? checkAndApply() : ''"
							>
								<span
									:class="LoaderStatus && !warning ? 'invisible' : 'pointer'"
								>
									{{ cancel ? "Confirm" : type ? "Accept" : "Reject" }}
								</span>
							</b-button>

							<div v-if="LoaderStatus && !warning" class="loader-pos-new">
								<Loader />
							</div>
						</div>
					</div>
				</footer>
			</main>
		</b-modal>

		<b-modal
			id="warningModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			v-model="warning"
		>
			<main>
				<header class="modal-top p-3">
					<div class="d-flex justify-content-between align-items-start">
						<div class="gap-3 width-97 mob-main">
							<img src="@/assets/mobile/accset/mb-warn.svg" alt="" />
							<div class="mob-text-center">
								<h2 class="candash-modal-head">Warning</h2>
								<h3
									class="candash-desc mt-2 text-344054"
									style="line-height: 18px"
								>
									We have noticed that you have been canceling interviews
									repeatedly. If this continues, your account will be suspended
									for one week.
								</h3>
							</div>
						</div>
						<div class="pointer" id="hideinmobile">
							<img
								@click="warning = false"
								class="rotate-on-hover"
								src="@/assets/newdesign/dashboard/blueCross.svg"
								alt
							/>
						</div>
					</div>
				</header>
				<footer
					style="border: none !important"
					class="candash-modal-footer d-flex align-items-center justify-content-end mob-jc-center"
				>
					<div class="position-relative">
						<b-button
							class="candash-addBtn"
							:class="!warningLoaderStatus ? 'pointer' : 'opac-5'"
							@click="
								!warningLoaderStatus
									? ((warningLoaderStatus = true), cancelInt('force'))
									: ''
							"
						>
							<span :class="warningLoaderStatus ? 'invisible' : 'pointer'"
								>Okay</span
							>
						</b-button>
						<div v-if="warningLoaderStatus" class="loader-pos-new">
							<Loader />
						</div>
					</div>
				</footer>
			</main>
		</b-modal>
	</main>
</template>

<script>
import {
	acceptRejectInterview,
	cancelInterview,
	userInfo,
	rescheduleInterview,
} from "@/utils/apiFunctions";
import toast from "@/components/mixin/toast";
import Loader from "@/components/fixedcomponents/Loader.vue";
import Textarea from "@/components/InputComponents/Textarea.vue";
import { requiredIf, maxLength } from "vuelidate/lib/validators";
import {
  	showReschedule,
} from "@/components/PanelDasboard/panelHelpers";
import { mapGetters } from "vuex";

export default {
	name: "AcceptRejectModal",
	data() {
		return {
			LoaderStatus: false,
			warningLoaderStatus: false,
			reason: null,
			warning: false,
			cancelCount: 0,
		};
	},
	props: {
		showAcceptReject: Boolean,
		type: Boolean,
		cancel: Boolean,
		interview: Object,
		reschedule: Boolean,
	},
	validations: {
		reason: {
			required: requiredIf(function () {
				return this.cancel;
			}),
			maxLength: maxLength(256),
		},
	},
	components: { Loader, Textarea },
	mixins: [toast],
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
		modalHeading() {
			let text = this.cancel ? "Cancel" : this.type ? "Accept" : "Reject";
			return text;
		},	
	},
	methods: {
		showReschedule(){
			return showReschedule(this.interview, this.userInfo.userID);
		},
		getFormattedTime(dateString) {
			console.log("the date string", dateString);
			if (!dateString.endsWith("Z")) {
				dateString += "Z";
			}
			const date = new Date(dateString);

			const day = date.getDate().toString().padStart(2, "0");
			const shortMonth = date.toLocaleString("en-US", { month: "short" });
			const fullDay = date.toLocaleString("en-US", { weekday: "long" });
			const month = date.toLocaleString("en-US", { month: "long" });
			const year = date.getFullYear();

			let hours = date.getHours();
			const minutes = date.getMinutes().toString().padStart(2, "0");
			const ampm = hours >= 12 ? "PM" : "AM";
			hours = hours % 12;
			hours = hours ? hours : 12;
			return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
		},
		checkAndApply() {
			if (!this.cancel) this.acceptRejectInt();
			else if (this.warning) this.$emit("close-modal");
			else {
				this.$v.$touch();
				if (!this.$v.$invalid) this.cancelInt();
			}
		},
		async acceptRejectInt() {
			this.LoaderStatus = true;
			try {
				let payload;
				if (this.reschedule) {
					const interviewID = this.interview.interviewRequestInterviewID;
					payload = {
						interviewID: interviewID,
						action: this.type ? 1 : 0,
					};
				} else {
					payload = {
						interviewRequestID: this.interview.interviewRequestID,
						accept: this.type,
					};
				}
				let res;
				if (this.reschedule) {
					res = await rescheduleInterview(payload);
				} else {
					res = await acceptRejectInterview(payload);
				}
				if (res.status == 200) {
					let text = this.type ? "accepted" : "rejected";
					this.$emit("success", this.type);
					this.$nextTick(() => {
						if (this.reschedule) {
							this.successModal(
								`Successfully ${text}`,
								`Interview reschedule request has been ${text}`
							);
						} else {
							this.successModal(
								`Successfully ${text}`,
								`${this.interview.interviewRequestID} has been ${text}`
							);
						}
					});
				} else if (res.status == 409) {
					this.errorModal("Error", res.data.data.Detail);
				} else {
					this.errorModal("Error", "Something went wrong!");
				}
			} catch (error) {
				this.errorModal("Error", "Something went wrong!");
				console.error(error);
			} finally {
				this.LoaderStatus = false;
			}
		},
		async getuserInfo() {
			const res = await userInfo();
			if (res.status == 200) {
				this.$store.commit("userVUEX/setUserInfo", res.data.data);
			}
		},
		async cancelInt(force) {
			this.LoaderStatus = true;
			try {
				let payload = {
					interviewRequestID: this.interview.interviewRequestID,
					remarks: this.reason,
				};
				if (force) payload.force = true;
				const res = await cancelInterview(payload);
				if (res.status == 200) {
					this.warning = false;
					if (this.cancelCount >= 5) {
						await this.getuserInfo();
						this.$emit("success", true);
					} else this.$emit("success");
					this.$nextTick(() => {
						if (this.cancelCount >= 5) {
							this.successModal(
								`${this.interview.interviewRequestID} has been cancelled`,
								`Your account has been suspended for seven days.`
							);
						} else {
							this.successModal(
								`Successfully cancelled`,
								`${this.interview.interviewRequestID} has been cancelled`
							);
						}
					});
				} else if (res.status == 409) {
					this.cancelCount = res.data.data.interviewCancellationCount;
					this.warning = true;
				} else {
					this.errorModal("Error", "Something went wrong!");
				}
			} catch (error) {
				this.errorModal("Error", "Something went wrong!");
				console.error(error);
			} finally {
				this.LoaderStatus = false;
				this.warningLoaderStatus = false;
			}
		},
	},
};
</script>

<style scoped>
.reason-inner {
	border-top: 1px solid #d7d7d7;
}

.mob-main {
	display: flex;
	align-items: flex-start;
}

.reschedule-link {
	color: var(--bg-proTheme);
	transition: color 0.2s ease;
	text-decoration: underline;
}

/* Media query for mobile view */
@media only screen and (max-width: 767px) {
	.mob-main {
		align-items: center;
		flex-direction: column;
	}

	.mob-text-center {
		text-align: center;
	}

	.mob-jc-center {
		justify-content: center !important;
	}
}
</style>
